import { useT } from '../../i18n/i18n';
import { useStore } from '../../state/createStore';
import { acceptPushPrompt, declinePushPrompt, pushStore } from '../../state/pushRegistration';
import { ConfirmSheet } from '../../ui/components';

// The notification explainer (Owner contract 2026-09-13 §40): shown once, after the first advanced
// review was started, BEFORE the system prompt. 暂不 is a real choice: the job runs, the result
// reaches the AI Task Center and the item exactly the same way.
export function PushPermissionHost() {
  const { t } = useT();
  const open = useStore(pushStore, (s) => s.promptOpen);
  if (!open) return null;
  return <ConfirmSheet title={t('push.explainTitle')} body={t('push.explainBody')} confirmLabel={t('push.allow')} cancelLabel={t('push.later')} onConfirm={() => void acceptPushPrompt()} onCancel={declinePushPrompt} testId="push-permission-sheet" />;
}
